<app-picker
  [classes]="'icon main-grey text-capitalize'"
  [rotateIcon]="explore || isBasketEmpty"
  [picker]="searchResult.categoriesPicker"
  [title]="searchParams?.locationName"
  (selectedValue)="onRestaurantsPickerSelected($event)"
></app-picker>
